<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-上传设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--文件上传设置-->
      <div class="common-form">监控设置</div>
      


      <el-form-item label="API Key" prop="days" >
        <el-input v-model="form.jk_api_key" type="text"  placeholder="请输入API Key" class="max-w460">
        </el-input>

      </el-form-item>


      <el-form-item label="Secret Key" prop="days" >
        <el-input v-model="form.jk_secret_key" type="password"  placeholder="请输入Secret Key" class="max-w460">
        </el-input>

      </el-form-item>



      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        jk_api_key:"",
        jk_secret_key:"",
      },
      showNmae:'',
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.tpDetail({}, true)
        .then(data => {
          let vars = data.data.vars.values;
          self.form = vars;

        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editTp(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，上传设置成功',
            type: 'success'
          });
          // self.$router.push('/setting/Storage');
        })
        .catch(error => {
          self.loading = false;
        });
    },
    //监听单选按钮
    getRadio(val) {}
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/tp/index.vue